/**
 * ReviewStarPicker — the required 1-5 star control shared by the M11-A
 * review-capture surfaces (`WorkedTogetherReviewSheet` and
 * `ReviewCloseUpgradeModal`, plan 320/322).
 *
 * Extracted because the two sheets are deliberately separate SURFACES with
 * identical rating mechanics: the accessible star markup (per-star button,
 * `aria-pressed`, "N stars" label, filled/hollow glyph) is one control, and
 * two copies of it drift into two different rating affordances.
 *
 * The wrapper's `data-testid` stays caller-supplied so each sheet keeps its
 * own surface-scoped hook.
 */

const STAR_VALUES = [1, 2, 3, 4, 5];

export interface ReviewStarPickerProps {
  /** Currently selected rating; 0 means "nothing picked yet". */
  value: number;
  onChange: (stars: number) => void;
  testId: string;
}

export function ReviewStarPicker({
  value,
  onChange,
  testId,
}: ReviewStarPickerProps) {
  return (
    <div className="flex gap-1" data-testid={testId}>
      {STAR_VALUES.map((star) => (
        <button
          aria-label={`${star} star${star === 1 ? "" : "s"}`}
          aria-pressed={value >= star}
          className="text-2xl leading-none text-muted-foreground"
          key={star}
          onClick={() => onChange(star)}
          type="button"
        >
          <span aria-hidden="true">{value >= star ? "★" : "☆"}</span>
        </button>
      ))}
    </div>
  );
}
